/* eslint-disable react/react-in-jsx-scope */
import { ExportCsv, GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from '@mui/x-data-grid-pro';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';
import { getDateOperators } from '../../utils/getDateOperators';
import { CustomCell } from './components/custom-cell';
import { DataGridDownloadButton } from '../../components/data-grid-download-button';

export const TABLE_ORDERS_COLLECTION_COLUMNS = modes => [
	{
		headerName: ' ',
		field: 'empty',
		width: 100,
		sortable: false,
		filterable: false,
		disableColumnMenu: true,
		disableExport: true,
	},
	{
		headerName: '#',
		field: 'id',
		width: 50,
		minWidth: 50,
		align: 'center',
		type: 'number',
		cellClassName: 'id',
		sortable: false,
		filterable: false,
		disableColumnMenu: true,
		headerAlign: 'center',
		renderCell: params => CustomCell(params),
		renderHeader: () => (
			<ExportCsv
				render={DataGridDownloadButton()}
				options={{
					utf8WithBom: true,
					delimiter: ';',
				}}
			/>
		),
	},
	{
		headerName: 'Номер заказа',
		field: 'number',
		flex: 1,
		filterOperators: getStringOperators(),
	},
	{
		headerName: 'Адрес отгрузки',
		field: 'address_from',
		flex: 1,
		sortable: false,
		filterable: false,
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (!value) {
				return value;
			}

			return value.address;
		},
	},
	{
		headerName: 'Адрес доставки',
		field: 'address_to',
		minWidth: 150,
		flex: 1,
		sortable: false,
		filterable: false,
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (!value) {
				return value;
			}

			return value.address;
		},
	},
	{
		headerName: 'Т-режим',
		field: 'mode_id',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		sortable: false,
		filterable: false,
		type: 'singleSelect',
		valueOptions: modes,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.mode) {
				return '';
			}

			return row.mode.id;
		},
		valueFormatter: (value, row) => {
			if (!row.mode) {
				return '';
			}

			return row.mode.name_with_symbol;
		},
	},
	{
		headerName: 'Масса, кг',
		field: 'weight',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
	{
		headerName: 'Объем, м³',
		field: 'volume',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
	{
		headerName: 'Места, шт',
		field: 'place',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(),
	},
	{
		headerName: 'Стоимость груза',
		field: 'cost',
		flex: 1,
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
	{
		headerName: 'Примечание',
		field: 'comment',
		flex: 1,
		sortable: false,
		filterOperators: getStringOperators(),
	},
];

export const TABLE_COLLECTION_COLUMNS = modes => [
	{
		headerName: ' ',
		field: 'empty',
		width: 50,
		sortable: false,
		filterable: false,
		disableColumnMenu: true,
		disableExport: true,
	},
	{
		...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
		headerAlign: 'center',
		renderHeader: () => (
			<ExportCsv
				render={DataGridDownloadButton()}
				options={{
					utf8WithBom: true,
					delimiter: ';',
				}}
			/>
		),
	},
	{
		headerName: 'Адрес отгрузки',
		field: 'address_from',
		flex: 1,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (!value) {
				return value;
			}

			return value.address;
		},
	},
	{
		headerName: 'Адрес доставки',
		field: 'address_to',
		minWidth: 100,
		flex: 1,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (!value) {
				return value;
			}

			return value.address;
		},
	},
	{
		headerName: 'Дата доставки',
		field: 'date_to',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getDateOperators(),
		valueGetter: value => {
			if (!value) {
				return value;
			}

			return new Date(value).toLocaleDateString('ru-RU');
		},
	},
	{
		headerName: 'Планируемая дата отгрузки',
		field: 'pickup_at',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getDateOperators(),
		valueGetter: value => {
			if (!value) {
				return value;
			}

			return new Date(value).toLocaleDateString('ru-RU', {
				hour: '2-digit',
				minute: '2-digit',
			});
		},
	},
	{
		headerName: 'Планируемая дата доставки',
		field: 'drop_at',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getDateOperators(),
		valueGetter: value => {
			if (!value) {
				return value;
			}

			return new Date(value).toLocaleDateString('ru-RU', {
				hour: '2-digit',
				minute: '2-digit',
			});
		},
	},
	{
		headerName: 'Т-режим',
		field: 'mode_id',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		sortable: false,
		type: 'singleSelect',
		valueOptions: modes,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.mode) {
				return '';
			}

			return row.mode.id;
		},
		valueFormatter: (value, row) => {
			if (!row.mode) {
				return '';
			}

			return row.mode.name_with_symbol;
		},
	},
	{
		headerName: 'Кол. заказов',
		field: 'orders_count',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(['isAnyOf']),
	},
	{
		headerName: 'Масса, кг',
		field: 'weight',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(['isAnyOf']),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
	{
		headerName: 'Объем, м³',
		field: 'volume',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(['isAnyOf']),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
	{
		headerName: 'Места, шт',
		field: 'place',
		headerAlign: 'center',
		align: 'center',
		flex: 1,
		filterOperators: getNumericOperators(['isAnyOf']),
	},
	{
		headerName: 'Стоимость груза',
		field: 'cost',
		flex: 1,
		filterOperators: getNumericOperators(['isAnyOf']),
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
];

export const TABLE_ORDER_GROUPS_COLUMNS = () => [
	{
		headerName: '#',
		field: 'id',
		width: 50,
		minWidth: 50,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		sortable: false,
		filterable: false,
		disableColumnMenu: true,
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Название',
		field: 'name',
		width: 200,
		filterOperators: getStringOperators(),
		colSpan: (value, row) => {
			if (row.process) {
				return 3;
			}

			return undefined;
		},
		valueFormatter: (value, row) => {
			if (row.process) {
				return row.process.title;
			}

			return row.name;
		},
	},
	{
		headerName: 'Кол. заказов',
		field: 'orders_count',
		flex: 1,
		filterable: false,
	},
	{
		headerName: 'Кол. точек',
		field: 'collection_count',
		flex: 1,
		filterable: false,
	},
	{
		headerName: 'Масса, кг',
		field: 'orders_sum_weight',
		flex: 1,
		filterable: false,
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Объем, м³',
		field: 'orders_sum_volume',
		width: 130,
		filterable: false,
		renderCell: params => CustomCell(params),
	},
];

export const TABLE_ORDER_GROUPS_WITH_WAYS_COLUMNS = () => [
	{
		headerName: '#',
		field: 'id',
		width: 50,
		minWidth: 50,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		sortable: false,
		filterable: false,
		disableColumnMenu: true,
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Название',
		field: 'name',
		flex: 2,
		width: 200,
		filterOperators: getStringOperators(),
		valueFormatter: (value, row) => {
			if (row.process) {
				return row.process.title;
			}

			return row.name;
		},
	},
	{
		headerName: 'Кол. маршрутов',
		field: 'ways_count',
		flex: 1,
		filterable: false,
	},
];

export const TABLE_ORDER_WAYS_COLUMNS = () => [
	{
		headerName: ' ',
		field: 'empty',
		width: 50,
		sortable: false,
		filterable: false,
		disableColumnMenu: true,
		disableExport: true,
	},
	{
		...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
		headerAlign: 'center',
		renderHeader: () => (
			<ExportCsv
				render={DataGridDownloadButton()}
				options={{
					utf8WithBom: true,
					delimiter: ';',
				}}
			/>
		),
	},
	{
		headerName: '#',
		field: 'id',
		width: 50,
		minWidth: 50,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		sortable: false,
		filterable: false,
		disableColumnMenu: true,
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Название',
		field: 'name',
		width: 150,
		filterOperators: getStringOperators(),
	},
	{
		headerName: 'Кол. заказов',
		field: 'orders_count',
		flex: 1,
		filterable: false,
	},
	{
		headerName: 'Кол. точек',
		field: 'collection_count',
		flex: 1,
		filterable: false,
	},
	{
		headerName: 'КМ',
		field: 'distance',
		flex: 1,
		filterable: false,
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
	{
		headerName: 'Время',
		field: 'total_time',
		flex: 1,
		filterable: false,
	},
	{
		headerName: 'Стоимость груза',
		field: 'orders_sum_cost',
		flex: 1,
		filterable: false,
		renderCell: params => CustomCell(params),
		valueFormatter: value => {
			if (typeof value === 'number') {
				return value.toString().replace('.', ',');
			}

			return value ?? '';
		},
	},
	{
		headerName: 'Масса, кг',
		field: 'orders_sum_weight',
		flex: 1,
		filterable: false,
		renderCell: params => CustomCell(params),
		valueGetter: (value, row) => {
			if (!row.orders_sum_weight_with_rate) {
				return '';
			}

			return `${row.orders_sum_weight_with_rate.toString().replace('.', ',')}/${
				row.weight_with_recycling.toString().replace('.', ',') ?? ''
			}`;
		},
	},
	{
		headerName: 'Объем, м³',
		field: 'orders_sum_volume',
		flex: 1,
		filterable: false,
		renderCell: params => CustomCell(params),
		valueGetter: (value, row) => {
			if (!row.orders_sum_weight_with_rate) {
				return '';
			}

			return `${row.orders_sum_weight_with_rate.toString().replace('.', ',')}/${
				row.weight_with_recycling.toString().replace('.', ',') ?? ''
			}`;
		},
	},
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
